import axios from "../utils/axios.wrapper";

// ==================== GET====================

export const getSupplierOrders = async () => {
  const { data } = await axios.get("/SupplierOrder");
  return data.items || data;
};


export const getActiveSupplierOrders = async () => {
  const { data } = await axios.get("/SupplierOrder/active");
  return data.items || data;
};

export const getInactiveSupplierOrders = async () => {
  const { data } = await axios.get("/SupplierOrder/inactive");
  return data.items || data;
};


export const getSupplierOrderById = async (id) => {
  const { data } = await axios.get(`/SupplierOrder/${id}`);
  return data;
};

export const getSupplierOrdersBySupplier = async (supplierId) => {
  const { data } = await axios.get(`/SupplierOrder/supplier/${supplierId}`);
  return data.items || data;
};


export const getSupplierOrdersByShop = async (shopId) => {
  const { data } = await axios.get(`/SupplierOrder/shop/${shopId}`);
  return data.items || data;
};


export const getSupplierOrdersByStatus = async (statusId) => {
  const { data } = await axios.get(`/SupplierOrder/status/${statusId}`);
  return data.items || data;
};


export const getSupplierOrdersByDateRange = async (filter) => {
  const response = await axios.post('/SupplierOrder/daterange', filter);
   const data = response.data;
  return data.items || data;
};

export const getSupplierOrdersPaginated = async (filter = {}) => {
  const { data } = await axios.get("/SupplierOrder/paginated", {
    params: {
      startDate: filter.startDate,
      endDate: filter.endDate,
      page: filter.page || 1,
      pageSize: filter.pageSize || 10
    }
  });
  return data;
};

// ==================== CREATE  ====================


export const createSupplierOrder = async (supplierOrder) => {
 
  const { data } = await axios.post("/SupplierOrder/create", supplierOrder);
  return data;
};


// ==================== UPDATE ====================

export const updateSupplierOrder = async (id, supplierOrder) => {
  
  const { data } = await axios.put(`/SupplierOrder/${id}`, supplierOrder);
  return data;
};
// ==================== DELETE  ====================

export const softDeleteSupplierOrder = async (id) => {
  const { data } = await axios.delete(`/SupplierOrder/${id}`);
  return data;
};

export const hardDeleteSupplierOrder = async (id) => {
  const { data } = await axios.delete(`/SupplierOrder/hard/${id}`);
  return data;
};

export const cancelSupplierOrder = async (id) => {
   const { data } = await axios.delete(`/SupplierOrder/cancel/${id}`);
  return data;
};

// ==================== SUPPLIER ORDER LINES ====================

export const getAllSupplierOrderLines = async () => {
  const { data } = await axios.get("/SupplierOrderLine");
  return data.items || data;
};

export const getSupplierOrderLineById = async (id) => {
  const { data } = await axios.get(`/SupplierOrderLine/${id}`);
  return data;
};

export const getSupplierOrderLinesByOrderId = async (supplierOrderId) => {
  const { data } = await axios.get(`/SupplierOrderLine/order/${supplierOrderId}`);
 return data.items || data;};

export const createSupplierOrderLine = async (line) => {
  const payload = {
    productId: line.productId,
    unitId: line.unitId,
    quantity: line.quantity,
     SupplierOrderLineNotes: line.SupplierOrderLineNotes
  };
  const { data } = await axios.post("/SupplierOrderLine/create", payload);
  return data;
};

//update orderline
export const updateSupplierOrderLine = async (id, line) => {
  const payload = {
    supplierOrderLineId: id,
    productId: line.productId,
    unitId: line.unitId,
    quantity: line.quantity
  };
  const { data } = await axios.put(`/SupplierOrderLine/${id}`, payload);
  return data;
};

export const deleteSupplierOrderLine = async (id) => {
  const { data } = await axios.delete(`/SupplierOrderLine/${id}`);
  return data;
};

// ==================== PRINT / EXPORT ====================

export const getSupplierOrderForPrint = async (id) => {
  const { data } = await axios.get(`/SupplierOrder/${id}/print`);
  return data;
};

export const generateSupplierOrderPDF = async (id) => {
  const response = await axios.get(`/SupplierOrder/${id}/pdf`, {
    responseType: 'blob',
  });
  return response;
};

export const validateSupplierOrder = async (id) => {
  const response = await axios.patch(`/SupplierOrder/${id}/validate`);
  return response.data;
};

export const confirmSupplierOrder = async (id) => {
  const response = await axios.patch(`/SupplierOrder/${id}/confirm`);
  return response.data;
};

// ==================== SERVICE OBJECT ====================

export const supplierOrderService = {
  // Supplier Orders
  getSupplierOrders,
  getActiveSupplierOrders,
  getInactiveSupplierOrders,
  getSupplierOrderById,
  getSupplierOrdersBySupplier,
  getSupplierOrdersByShop,
  getSupplierOrdersByStatus,
  getSupplierOrdersByDateRange,
  getSupplierOrdersPaginated,
  createSupplierOrder,
  updateSupplierOrder,
  softDeleteSupplierOrder,
  hardDeleteSupplierOrder,
  cancelSupplierOrder,
  
  // Supplier Order Lines
  getAllSupplierOrderLines,
  getSupplierOrderLineById,
  getSupplierOrderLinesByOrderId,
  createSupplierOrderLine,
  updateSupplierOrderLine,
  deleteSupplierOrderLine,
  
  // Print/Export
  getSupplierOrderForPrint,
  generateSupplierOrderPDF,
};